<template>
    <div>
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#fff'" :backcolor="getCourseMainColor(courseId)" @returnBack="goToBack"></HeaderNav>
        <div class="imgLazyLoadHead"><img v-bind:src="getheadImage()"/></div>
        <div v-bind:style="{backgroundColor:getCourseSubColor(courseId2)}">
            <BigCatBeforeItem :lessonArray="objBigCatHomeInfo.freeTrial"
                             :totalPartCount="totalPartCount.toString()"
                             :courseId="courseId.toString()"
                             :isFreeTrial="'1'" @lessonClick="freeLessonClick"/>
            <div class="all_lesson" :style="{color:'white'}">
                <div class="all_lesson_line" :style="{backgroundColor:'white', 'margin-right': '10px'}"></div>
                <div class="all_lesson_title">全部课程</div>
                <div class="all_lesson_line" :style="{backgroundColor:'white', 'margin-left': '10px'}"></div>
            </div>
            <div class="lesson_content">
                <BigCatBeforeItem :lessonArray="objBigCatHomeInfo.lessonArray"
                                 :totalPartCount="totalPartCount.toString()"
                                 :courseId="courseId.toString()" @lessonClick="lessonClick"/>
                <div class="lesson_list_bottom" :style="{'height': adapterBigScreenHeight()}"></div>
            </div>
            <div class="words_before_bottom" v-bind:style="{'background-color':getCourseBuyButtonColor(courseId), 'margin-bottom': adapterBigScreen()}" @click="buyClick">
                <div class="title">购买课程</div>
                <div class="buy" v-bind:style="{color:getCourseBuyButtonColor(courseId)}">立即前往 ></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {MessageBox} from "mint-ui";

    export default {
        data() {
            return {
                selected: '1',
                courseId: parseInt(this.$route.query.courseId),
                courseId2: 0,
                objBigCatHomeInfo: {},
                totalPartCount: 4
            }
        },
        methods: {
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        var vUrl = "readingclubapp:gobackMyCourse";
                        document.location = vUrl;
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            getheadImage:function(){
                return require('@/assets/bigcat' + this.courseId + '.png');
            },
            adapterBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "0px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "36px" : "0px";
            },
            adapterBigScreenHeight: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "80px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "116px" : "80px";
            },
            buyClick:function(){
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    if (that.isAppIos()) {
                        let vYouZanUrl = this.objBigCatHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');
                        let vUrl = "readingclubapp:buyWordsBefore:" + that.courseId + ":" + vYouZanUrl;
                        document.location = vUrl;
                    }

                    if (that.isAppAndroid()) {
                        window.note.buyWordsBefore(that.courseId, this.objBigCatHomeInfo.buyUrl);
                    }
                } else {
                    that.$router.push({name: 'excessivebuy', query: {buyUrl: that.objBigCatHomeInfo.buyUrl}});
                }
            },
            freeLessonClick: function (pk) {
                this.$router.push({
                    name: 'BLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            lessonClick: function (pk) {
                window.console.log(pk);

                MessageBox.confirm('', {
                    message: ' ',
                    title: '要先购买才能上课哦～快去购买吧！',
                    showConfirmButton:false,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    cancelButtonText:'知道了'
                });
            },
            lessonIntroduceClick:function(){
                //this.$router.push({name: 'pageView', query: {url: "https://www.xiaohuasheng.cn/mtesthome_"+ this.obj240WordsHomeInfo.articleId +"/come_1"}});
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let isIos = that.isAppIos() ? 1 : 0;
            let url = "bigCat/getHomeInfo2/" + vCourseId + "/0/" + isIos;

            that.$axios.get(url).then((response) => {
                window.console.log(JSON.stringify(response.data))
                that.objBigCatHomeInfo = response.data;
                that.courseId = vCourseId;
                that.courseId2 = vCourseId;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
    }
</script>

<style scoped>
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .course_list_content {
        height: auto;
    }
    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .lesson_introduce {
        text-align: center;
    }
    .lesson_introduce div {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
    }
    .lesson_list_bottom {
        height: 50px;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    .Words_glossary_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }
    .Words_glossary_wordsitem {
        position: relative;
        height: 60px;
    }
    .Words_glossary_wordsitem .Word {
        position: absolute;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        background-color: white;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .Words_glossary_wordsitem .Word span {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        color: #999999;
        font-weight: normal;
    }
    .Words_glossary_wordsitem .point {
        text-align: center;
        font-size: 14px;
        color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .Words_glossary_wordsitem .lesson_name {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: white;
        font-size: 15px;
    }
    .Words_glossary_indexs {
        position: fixed;
        bottom: 30px;
        right: 0;
        z-index: 999;
    }
    .Words_glossary_indexs .Words_glossary_indexsitem {
        font-size: 10px;
        font-weight: bold;
        color: #333333;
        height: 15px;
        width: 25px;
    }
    .bubbleContainer{
        position: absolute;
        bottom: 0px;
        left: calc(50% + (50% - 120px)/2);
        padding-bottom: 6px;
    }
    .bubbleContainer .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        bottom: 0px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer .img img {
        width: 12px;
    }
    .all_lesson {
        margin-top:15px;
        margin-bottom: 10px;
        text-align: center;
        font-size: 15px;
    }
    .all_lesson {
        margin-top:40px;
        text-align: center;
    }
    .all_lesson .all_lesson_line {
        width: 56px;
        height: 1px;
        display: inline-block;
        vertical-align: middle;
    }
    .all_lesson .all_lesson_title {
        font-size: 15px;
        display: inline-block;
    }
    .words_before_bottom {
        position: fixed;
        bottom: 0px;
        width: 100%;
        height: 50px;
    }
    .words_before_bottom .title {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        font-size: 17px;
        font-weight: bold;
        color: white;
    }
    .words_before_bottom .buy {
        width: 85px;
        height: 30px;
        line-height: 30px;
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
        background-color: white;
        font-size: 13px;
        font-weight: normal;
        text-align: center;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
    }
</style>